import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { ServicesProvider } from '../ServicesProvider.js';
import { Services } from './Services.js';
import { servicesProviderInternalFeesDataSchema } from './ServicesProviderInternalFeesData.js';

class ServicesProviderInternalFees extends ServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderInternalFeesDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderInternalFees.validation', `ServicesProviderInternalFees data validation failed: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.INTERNAL_FEES,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.INTERNAL_FEES, ServicesProviderInternalFees);

export { ServicesProviderInternalFees };
//# sourceMappingURL=ServicesProviderInternalFees.js.map
